import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, Paper, Box, Typography, CircularProgress, Chip
} from '@mui/material';
import { SearchOff } from '@mui/icons-material';

const statusColors = {
  active: 'success', available: 'success', paid: 'success', approved: 'success', completed: 'success', accepted: 'success',
  draft: 'default', pending: 'warning', pending_approval: 'warning', processing: 'info', confirmed: 'info',
  delivered: 'primary', partially_paid: 'warning', sent: 'info', released: 'primary', ready_for_release: 'warning', unpaid: 'default',
  cancelled: 'error', rejected: 'error', void: 'error', failed: 'error',
  sold: 'secondary', reserved: 'warning', maintenance: 'warning',
  overdue: 'error', returned: 'warning', refunded: 'info', not_required: 'default',
};

export const StatusChip = ({ status }) => (
  <Chip
    label={status?.replace(/_/g, ' ')?.toUpperCase() || 'N/A'}
    color={statusColors[status] || 'default'}
    size="small"
    sx={{ fontWeight: 600, fontSize: '0.7rem' }}
  />
);

const DataTable = ({ columns, rows, loading, total, page, rowsPerPage,
                      onPageChange, onRowsPerPageChange, emptyMessage = 'No records found' }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Paper sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.key} align={col.align || 'left'}
                  sx={{ fontWeight: 700, whiteSpace: 'nowrap', width: col.width }}>
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length}>
                  <Box sx={{ py: 6, textAlign: 'center' }}>
                    <SearchOff sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography color="text.secondary">{emptyMessage}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : rows.map((row, idx) => (
              <TableRow key={row.id || idx} hover
                sx={{ '&:last-child td': { border: 0 }, cursor: 'pointer' }}>
                {columns.map((col) => (
                  <TableCell key={col.key} align={col.align || 'left'}>
                    {col.render ? col.render(row[col.key], row) : row[col.key] ?? '—'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {total !== undefined && (
        <TablePagination
          component="div"
          count={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          rowsPerPageOptions={[10, 20, 50, 100]}
        />
      )}
    </Paper>
  );
};

export default DataTable;
